export var TableName;
(function (TableName) {
    TableName["User"] = "User";
    TableName["Role"] = "Role";
    TableName["Permission"] = "Permission";
    TableName["PermissionRelation"] = "PermissionRelation";
    TableName["HistoryLog"] = "HistoryLog";
    TableName["Group"] = "Group";
    TableName["Profile"] = "Profile";
    TableName["Token"] = "Token";
    TableName["Media"] = "Media";
    TableName["MailTemplate"] = "MailTemplate";
    TableName["Partner"] = "Partner";
    TableName["Card"] = "Card";
    TableName["Benefit"] = "Benefit";
})(TableName || (TableName = {}));
export const TableNameTranslation = {
    [TableName.User]: 'Użytkownik',
    [TableName.Role]: 'Rola',
    [TableName.Permission]: 'Uprawnienie',
    [TableName.PermissionRelation]: 'Uprawnienie relacji',
    [TableName.HistoryLog]: 'Historia',
    [TableName.Group]: 'Grupa',
    [TableName.Profile]: 'Profil',
    [TableName.Token]: 'Token',
    [TableName.Media]: 'Media',
    [TableName.MailTemplate]: 'Szablon poczty',
    [TableName.Partner]: 'Partner',
    [TableName.Card]: 'Karta',
    [TableName.Benefit]: 'Świadczenie'
};
//# sourceMappingURL=tableName.enum.js.map